import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'Components/forms/text-field/TextField';
import './CurrencySingleInput.scss';
import '../_ranges.scss';
import SelectInput from '../select-input/SelectInput';
import Label from 'Components/forms/label/Label';
import { preciseToDecimal } from 'Utils/formatting';

class CurrencySingleInput extends Component {
  constructor(props) {
    super(props);

    const idLow = `${this.props.title.replace(/ /, '-')}-low`;

    this.state = {
      focused: false,
      start: this.props.filterLow,
      lowKey: idLow,
      currentSearchTerm: '',
      currencyList: this.props.currencyList,
      compareList: this.props.compareList,
      currencies: [],
    };
  }

  componentWillMount() {
    this.setCurrencyList(this.props);
    this.setState({
      selectedCurrency: { text: this.props.selectedCurrency, value: this.props.selectedCurrency },
      selectedCompareVal: { text: this.props.selectedCompareVal, value: this.props.selectedCompareVal }
    })
  }

  setCurrencyList(props) {
    let currencyList = [...props.currencyList];
    let compareList = [...props.compareList];
    this.setState({
      currencyList,
      compareList
    });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.filterLow !== this.state.start) {
      this.setState({
        focused: false,
        start: newProps.filterLow,
      });
    }
    if (this.state && this.props.currencyList.length != newProps.currencyList.length) {
      this.setCurrencyList(newProps);
    }
    if (this.props.selectedCurrency != newProps.selectedCurrency) {
      this.setState({
        selectedCurrency: { text: newProps.selectedCurrency, value: newProps.selectedCurrency }
      })
    }
    if (this.props.selectedCompareVal != newProps.selectedCompareVal) {
      this.setState({
        selectedCompareVal: { text: newProps.selectedCompareVal, value: newProps.selectedCompareVal }
      });
    }
  }

  preciseToDecimal(value, upToDecimalPoint) {
    return (Math.round(value * 100) / 100).toFixed(upToDecimalPoint);
  }

  onBlur = (e) => {
    const float = new RegExp(/^-?\d*(\.\d+)?\.?$/);
    const stateKey = (e.target.name === this.state.highKey) ? 'end' : 'start';
    const value = this.props.id === 'case_trans_amount' || this.props.id === 'mre_dispute_amount' ? e.target.value : this.preciseToDecimal(e.target.value, 2);
    if ((float.test(value) && !Number.isNaN(value) && this.count(value, '.') <= 1)
      || value === '') {
      this.setState({ [stateKey]: value });
      this.props.onChange(value, e.target.id);
    }
    this.setState({ focused: false });
  }

  onFocus = () => {
    this.setState({ focused: true });
  }

  setField = (e) => {
    const float = new RegExp(/^-?\d*(\.\d+)?\.?$/);
    const stateKey = (e.target.name === this.state.highKey) ? 'end' : 'start';
    const value = e.target.value;

    if ((float.test(value) && !Number.isNaN(value) && this.count(value, '.') <= 1)
      || value === '') {
      this.setState({ [stateKey]: value });
      this.props.onChange(value, e.target.id);
    }
  }
  setCurrencyCode = (selectedCurrency) => {
    this.props.handleSelectedCurrency(selectedCurrency, this.props.id);
  }
  setCompareVal = (selectedCompareVal) => {
    this.props.handleSelectedCompareVal(selectedCompareVal, this.props.id)
  }

  count = (string, letter) => {
    let count = 0;
    for (let i = 0; i < string.length; i += 1) {
      if (string[i] === letter) {
        count += 1;
      }
    }
    return count;
  }





  get labelContent() {
    return (
      <span className="spanStyle">
        <Label extraStyle={{ fontSize: 12, fontWeight: 500, marginBottom: 0 }}>
          {this.props.title}
        </Label>
        {this.props.error && <span className="message-error">{this.props.error}</span>}
        {!this.props.error && this.props.labelTooltip}
      </span>
    );
  }

  render() {
    let style = this.props.disable || this.props.currencyCodeDisabled ? { border: '1px solid rgb(215, 220, 225)', cursor: 'not-allowed', pointerEvents: 'none' } : { border: '1px solid rgb(215, 220, 225)' };
    return (
      <TextField
        error={this.props.error}
        htmlFor={this.state.lowKey}
        labelContent={this.labelContent}
        fieldClass={this.state.focused ? 'field range-container focused' : 'field range-container'}
      >
        <div className="range-pair currency-range" style={{ marginTop: this.props.id == "mre_dispute_amount" ? "15px" : "" }}>
          {this.state.currencyList && this.state.currencyList.length > 0 && !this.props.isCurrencyLabel &&
            <div style={{ "border": "1px solid #c4c4c4", "margin-right": "5px" }}>
              <SelectInput
                name="Currency"
                dataList={this.state.currencyList}
                promptText="Currency"
                wrapperClass="select-menu__form"
                extraClass="option-box"
                id={this.props.id}
                promptOnly={true}
                handleSelection={this.setCurrencyCode}
                selectedItem={this.state.selectedCurrency}
                isDisabled={this.props.disable || this.props.currencyCodeDisabled ? true : false}
                isReadOnlyGreyDisable={this.props.disable || this.props.currencyCodeDisabled ? true : false}
                extraSpanClass='main-span-label'
              /></div>
          }
          {this.state.compareList && this.state.compareList.length > 0 && !this.props.isCompareLabel &&
            <div style={{ "border": "1px solid black", "margin-right": "5px" }}  >
              <SelectInput
                dataList={this.state.compareList}
                // promptText={this.state.selectedCompareVal.text}
                promptText="Select"
                wrapperClass="select-menu__form"
                promptOnly={true}
                extraStyle={{ fontSize: 12, fontWeight: 500, color: '#c4c4c4' }}
                id={this.props.id}
                handleSelection={this.setCompareVal}
                selectedItem={this.state.selectedCompareVal}
                isDisabled={this.props.disable || this.props.currencyCodeDisabled ? true : false}
                isReadOnlyGreyDisable={this.props.disable || this.props.currencyCodeDisabled ? true : false}
              />
            </div>
          }
          <input
            className={`field-input range-field low ${this.state.focused ? 'focused' : ''}`}
            name={this.state.lowKey}
            id={this.props.id}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            onChange={this.setField}
            type="text"
            value={this.state.start}
            disabled={this.props.disable ? true : false}
            placeholder={this.props.placeHolder ? this.props.placeHolder : ""}
            style={this.props.id == "mre_dispute_amount" ? { textIndent: "10px", cursor: this.props.disable ? "not-allowed" : "" } : {}}
            maxLength={this.props?.max}
          />
          {(this.props.isCurrencyLabel) && <Label extraStyle={{
            fontSize: 12, fontWeight: 500, color: '#7C7C89', paddingLeft: '10px',
            paddingTop: '5px'
          }}>
            {this.props.selectedCurrency}
          </Label>}
        </div>
        {!!this.props?.validationError && <span className="error-message"> {this.props?.validationError}</span>}
      </TextField>
    );
  }
}

CurrencySingleInput.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  error: PropTypes.string,
  filterLow: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  separatorText: PropTypes.string,
  currencyList: PropTypes.array.isRequired,
  compareList: PropTypes.array,
  handleSelectedCurrency: PropTypes.func,
  handleSelectedCompareVal: PropTypes.func,
  labelTooltip: PropTypes.object,
  max: PropTypes.string,
  validationError: PropTypes.string,
};

CurrencySingleInput.defaultProps = {
  filterLow: '',
  error: '',
  title: '',
  separatorText: 'to',
  currencyList: [],
  compareList: [],
  handleSelectedCompareVal: () => { },
  handleSelectedCurrency: () => { },
  labelTooltip: null,
  max: '',
  validationError: '',
};

export default CurrencySingleInput;
